import styled from 'styled-components';
import { BasketMandatoryFeesStyled } from '../../BasketMandatoryFeesStyled';
import { rem } from 'polished';

export const BasketMandatoryFeesDetailsOV = styled(BasketMandatoryFeesStyled)`
    .titleWrapper {
        .title {
            font-size: ${({ theme }) => theme.fontSizes.h3};
        }
    }
    
    .description {
        font-family: ${({ theme }) => theme.fonts.fontSecondary};
    }
    
    .fees {
        .item {
            &_description {
                font-family: ${({ theme }) => theme.fonts.fontSecondary};
            }
        }
    }
`;